import React from 'react'
import { SimpleSelect, type SimpleSelectProps } from '@retailer-platform/shared-components'
import { type SimpleOption } from '@retailer-platform/shared-components/src/common/select/utils/select.types'
import invert from 'lodash/invert'
import { useDomainMessages } from 'domains/products/utils/domain/intl'

const valuesMap = {
  yes: true,
  no: false,
}

const invertedValuesMap = invert(valuesMap)

interface ProductsYesNoSelectorProps extends Omit<SimpleSelectProps<boolean>, 'options'> {
  onChange: (v: boolean | undefined) => void
  value: boolean | undefined
}

type BinaryOption = SimpleOption<string>

export const ProductsYesNoSelector: React.FunctionComponent<ProductsYesNoSelectorProps> = ({
  value,
  onChange,
  placeholder,
  ...rest
}) => {
  const displayText = useDomainMessages({
    yes: 'productsDomain.search.yes',
    no: 'productsDomain.search.no',
  })

  const selectorOptions: BinaryOption[] = [
    { label: displayText.yes, value: 'yes' },
    { label: displayText.no, value: 'no' },
  ]

  return (
    <SimpleSelect
      options={selectorOptions}
      value={invertedValuesMap[value?.toString()]}
      placeholder={placeholder}
      isClearable
      onChange={val => {
        onChange(valuesMap[val])
      }}
      components={{
        SingleValue: props => [placeholder, props.data.label].filter(Boolean).join('  '),
      }}
      {...rest}
    />
  )
}
